// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronDown20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronDown20: FC<ChevronDown20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m16 8.62-6 4.913L4 8.62l1.007-1.238L10 11.466l4.993-4.085L16 8.619Z" />
        </svg>
    );
};

export default ChevronDown20;
